// extracted by mini-css-extract-plugin
module.exports = {"backButton":"treatmentHeaderContent_backButton__2FJFX","button":"treatmentHeaderContent_button__3ARdV","updateProfileButton":"treatmentHeaderContent_updateProfileButton__2xj6x"};